/**
 * useSyncStatus.ts
 * Store réactif partagé pour l'état de synchronisation du worker.
 *
 * Problème résolu : _globalProcessing dans useUploadWorker est un `let`
 * non réactif — les composants React ne se re-rendent pas quand il change.
 * Ce store Zustand minimaliste permet à n'importe quel composant de
 * s'abonner au statut de sync et de recevoir les mises à jour en temps réel.
 *
 * @version 1.0.0
 */

import { create } from 'zustand'

interface SyncStatusState {
  /** true pendant que le worker traite un ou plusieurs items */
  isSyncing:   boolean
  /** contractId en cours de traitement (null si idle) */
  currentItem: string | null
  /** Setters */
  setSyncing:    (v: boolean) => void
  setCurrentItem: (id: string | null) => void
}

export const useSyncStatus = create<SyncStatusState>((set) => ({
  isSyncing:      false,
  currentItem:    null,
  setSyncing:     (v) => set({ isSyncing: v }),
  setCurrentItem: (id) => set({ currentItem: id }),
}))
